
export default {
  getPackageStatusTagType(status){
    if(status==null)return '';
    let tagType = '';//Default tagType => SENT
      if(status.code==="INIT"){
        tagType = "info";
      }else if(status.code==="PACKAGED"){
        tagType = "";
      }else if(status.code==="SHIPPED"){
        tagType = "";
      }else if(status.code==="DELIVERED"){
        tagType = "success";
      }else if(status.code==="CANCELLED"){
        tagType = "danger";
      }
    return tagType;
  }
}
